<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-library-header">
            <div class="card-header trainer-card-header">
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <h4 class="card-title trainer-title">
                    <i class="nc-icon nc-books"></i>
                    Biblioteca de Ejercicios
                  </h4>
                  <p class="card-category trainer-subtitle">
                    Gestiona y organiza todos tus ejercicios
                  </p>
                </div>
                <div class="col-sm-6 text-right">
                  <button class="btn btn-light trainer-btn-add" @click="showAddExerciseModal = true">
                    <i class="nc-icon nc-simple-add"></i>
                    Nuevo Ejercicio
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estadísticas -->
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-books text-primary"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Total Ejercicios</p>
                    <p class="card-title trainer-number">{{ exercises.length }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-video-66 text-success"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Con Video</p>
                    <p class="card-title trainer-number">{{ exercisesWithVideo }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-favourite-28 text-warning"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Favoritos</p>
                    <p class="card-title trainer-number">{{ favoriteExercises }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-tag-content text-info"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Categorías</p>
                    <p class="card-title trainer-number">{{ categories.length }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filtros y Búsqueda -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <input 
                      type="text" 
                      class="form-control" 
                      placeholder="Buscar ejercicio..."
                      v-model="searchQuery"
                    >
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <select class="form-control" v-model="categoryFilter">
                      <option value="">Todas las categorías</option>
                      <option v-for="category in categories" :key="category" :value="category">
                        {{ category }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <select class="form-control" v-model="difficultyFilter">
                      <option value="">Todas las dificultades</option>
                      <option value="principiante">Principiante</option>
                      <option value="intermedio">Intermedio</option>
                      <option value="avanzado">Avanzado</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="trainer-filter-toggles">
                    <button 
                      class="btn btn-sm" 
                      :class="showFavoritesOnly ? 'trainer-btn-primary' : 'btn-outline-secondary'"
                      @click="showFavoritesOnly = !showFavoritesOnly"
                    >
                      <i class="nc-icon nc-favourite-28"></i> Favoritos
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Lista de Ejercicios -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Ejercicios ({{ filteredExercises.length }})</h6>
              <div class="card-tools">
                <button class="btn btn-sm" :class="viewMode === 'grid' ? 'trainer-btn-primary' : 'btn-outline-secondary'" @click="viewMode = 'grid'">
                  <i class="nc-icon nc-grid-45"></i>
                </button>
                <button class="btn btn-sm" :class="viewMode === 'list' ? 'trainer-btn-primary' : 'btn-outline-secondary'" @click="viewMode = 'list'">
                  <i class="nc-icon nc-bullet-list-67"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <!-- Vista Grid -->
              <div v-if="viewMode === 'grid'" class="row">
                <div v-for="exercise in filteredExercises" :key="exercise.id" class="col-lg-4 col-md-6 mb-4">
                  <div class="trainer-exercise-card">
                    <div class="trainer-exercise-image">
                      <img :src="exercise.image" :alt="exercise.name" v-if="exercise.image">
                      <div v-else class="trainer-exercise-placeholder">
                        <i class="nc-icon nc-image"></i>
                      </div>
                      <div class="trainer-exercise-overlay">
                        <button class="btn btn-sm btn-light" @click="toggleFavorite(exercise)">
                          <i class="nc-icon nc-favourite-28" :class="{ 'text-warning': exercise.favorite }"></i>
                        </button>
                        <button v-if="exercise.video" class="btn btn-sm btn-light" @click="playVideo(exercise)">
                          <i class="nc-icon nc-video-66"></i>
                        </button>
                      </div>
                    </div>
                    <div class="trainer-exercise-content">
                      <h6 class="trainer-exercise-name">{{ exercise.name }}</h6>
                      <p class="trainer-exercise-description">{{ exercise.description }}</p>
                      <div class="trainer-exercise-meta">
                        <span class="badge trainer-badge-category">{{ exercise.category }}</span>
                        <span class="badge trainer-badge-difficulty" :class="getDifficultyClass(exercise.difficulty)">
                          {{ exercise.difficulty }}
                        </span>
                      </div>
                      <div class="trainer-exercise-actions">
                        <button class="btn btn-sm btn-outline-primary" @click="editExercise(exercise)">
                          <i class="nc-icon nc-settings-gear-65"></i> Editar
                        </button>
                        <button class="btn btn-sm btn-outline-success" @click="addToWorkout(exercise)">
                          <i class="nc-icon nc-simple-add"></i> Añadir
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Vista Lista -->
              <div v-if="viewMode === 'list'" class="table-responsive">
                <table class="table trainer-exercises-table">
                  <thead>
                    <tr>
                      <th>Ejercicio</th>
                      <th>Categoría</th>
                      <th>Dificultad</th>
                      <th>Músculos</th>
                      <th>Equipamiento</th>
                      <th>Video</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="exercise in filteredExercises" :key="exercise.id">
                      <td>
                        <div class="trainer-exercise-info">
                          <img :src="exercise.image" :alt="exercise.name" class="trainer-exercise-thumb" v-if="exercise.image">
                          <div class="trainer-exercise-placeholder-thumb" v-else>
                            <i class="nc-icon nc-image"></i>
                          </div>
                          <div>
                            <strong>{{ exercise.name }}</strong>
                            <br><small class="text-muted">{{ exercise.description.substring(0, 50) }}...</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span class="badge trainer-badge-category">{{ exercise.category }}</span>
                      </td>
                      <td>
                        <span class="badge trainer-badge-difficulty" :class="getDifficultyClass(exercise.difficulty)">
                          {{ exercise.difficulty }}
                        </span>
                      </td>
                      <td>{{ exercise.muscles.join(', ') }}</td>
                      <td>{{ exercise.equipment }}</td>
                      <td>
                        <i v-if="exercise.video" class="nc-icon nc-video-66 text-success"></i>
                        <i v-else class="nc-icon nc-simple-remove text-muted"></i>
                      </td>
                      <td>
                        <div class="trainer-actions">
                          <button class="btn btn-sm" :class="exercise.favorite ? 'btn-warning' : 'btn-outline-warning'" @click="toggleFavorite(exercise)">
                            <i class="nc-icon nc-favourite-28"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-primary" @click="editExercise(exercise)">
                            <i class="nc-icon nc-settings-gear-65"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-success" @click="addToWorkout(exercise)">
                            <i class="nc-icon nc-simple-add"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para Nuevo Ejercicio -->
    <div class="modal" v-if="showAddExerciseModal" @click="showAddExerciseModal = false">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Nuevo Ejercicio</h5>
            <button type="button" class="close" @click="showAddExerciseModal = false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Nombre del Ejercicio</label>
                    <input type="text" class="form-control" placeholder="Nombre del ejercicio">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Categoría</label>
                    <select class="form-control">
                      <option value="">Seleccionar categoría</option>
                      <option v-for="category in categories" :key="category" :value="category">
                        {{ category }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Dificultad</label>
                    <select class="form-control">
                      <option value="principiante">Principiante</option>
                      <option value="intermedio">Intermedio</option>
                      <option value="avanzado">Avanzado</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Equipamiento</label>
                    <input type="text" class="form-control" placeholder="Mancuernas, Barra, Peso corporal...">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Músculos Trabajados</label>
                <input type="text" class="form-control" placeholder="Pectorales, Tríceps, Deltoides...">
              </div>
              <div class="form-group">
                <label>Descripción</label>
                <textarea class="form-control" rows="3" placeholder="Descripción detallada del ejercicio..."></textarea>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Imagen</label>
                    <input type="file" class="form-control" accept="image/*">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Video</label>
                    <input type="file" class="form-control" accept="video/*">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Instrucciones</label>
                <textarea class="form-control" rows="4" placeholder="Paso a paso para realizar el ejercicio..."></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showAddExerciseModal = false">Cancelar</button>
            <button type="button" class="btn trainer-btn-primary" @click="addExercise">Crear Ejercicio</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExerciseLibrary',
  data() {
    return {
      showAddExerciseModal: false,
      searchQuery: '',
      categoryFilter: '',
      difficultyFilter: '',
      showFavoritesOnly: false,
      viewMode: 'grid',
      categories: ['Fuerza', 'Cardio', 'Flexibilidad', 'Funcional', 'Rehabilitación'],
      exercises: [
        {
          id: 1,
          name: 'Press de Banca',
          description: 'Ejercicio fundamental para el desarrollo del pecho y tríceps',
          category: 'Fuerza',
          difficulty: 'intermedio',
          muscles: ['Pectorales', 'Tríceps', 'Deltoides'],
          equipment: 'Barra y Banco',
          image: '/static/img/tables/agenda.png',
          video: true,
          favorite: true
        },
        {
          id: 2,
          name: 'Sentadillas',
          description: 'Ejercicio básico para piernas y glúteos',
          category: 'Fuerza',
          difficulty: 'principiante',
          muscles: ['Cuádriceps', 'Glúteos', 'Isquiotibiales'],
          equipment: 'Peso corporal',
          image: '/static/img/tables/evernote.png',
          video: true,
          favorite: false
        },
        {
          id: 3,
          name: 'Burpees',
          description: 'Ejercicio completo de alta intensidad',
          category: 'Cardio',
          difficulty: 'avanzado',
          muscles: ['Todo el cuerpo'],
          equipment: 'Peso corporal',
          image: null,
          video: false,
          favorite: true
        },
        {
          id: 4,
          name: 'Plancha',
          description: 'Ejercicio isométrico para el core',
          category: 'Funcional',
          difficulty: 'intermedio',
          muscles: ['Core', 'Hombros'],
          equipment: 'Peso corporal',
          image: '/static/img/tables/stylus.jpg',
          video: true,
          favorite: false
        }
      ]
    }
  },
  computed: {
    exercisesWithVideo() {
      return this.exercises.filter(exercise => exercise.video).length;
    },
    favoriteExercises() {
      return this.exercises.filter(exercise => exercise.favorite).length;
    },
    filteredExercises() {
      let filtered = this.exercises;
      
      if (this.searchQuery) {
        filtered = filtered.filter(exercise => 
          exercise.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          exercise.description.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
      
      if (this.categoryFilter) {
        filtered = filtered.filter(exercise => exercise.category === this.categoryFilter);
      }
      
      if (this.difficultyFilter) {
        filtered = filtered.filter(exercise => exercise.difficulty === this.difficultyFilter);
      }
      
      if (this.showFavoritesOnly) {
        filtered = filtered.filter(exercise => exercise.favorite);
      }
      
      return filtered;
    }
  },
  methods: {
    getDifficultyClass(difficulty) {
      const classes = {
        'principiante': 'badge-success',
        'intermedio': 'badge-warning',
        'avanzado': 'badge-danger'
      };
      return classes[difficulty] || 'badge-secondary';
    },
    toggleFavorite(exercise) {
      exercise.favorite = !exercise.favorite;
    },
    playVideo(exercise) {
      this.$swal.fire({
        title: 'Reproducir Video',
        text: `Reproducir video de: ${exercise.name}`,
        icon: 'info',
        confirmButtonColor: '#9ACD32'
      });
    },
    editExercise(exercise) {
      this.$swal.fire({
        title: 'Editar Ejercicio',
        text: `Editar: ${exercise.name}`,
        icon: 'info',
        confirmButtonColor: '#9ACD32'
      });
    },
    addToWorkout(exercise) {
      this.$swal.fire({
        title: 'Añadir a Rutina',
        text: `${exercise.name} añadido a la rutina actual`,
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    },
    addExercise() {
      this.showAddExerciseModal = false;
      this.$swal.fire({
        title: 'Ejercicio Creado',
        text: 'El nuevo ejercicio ha sido añadido a la biblioteca',
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  --trainer-primary: #9ACD32;
  --trainer-secondary: #7CB342;
  --trainer-accent: #8BC34A;
  --trainer-dark: #689F38;
  --trainer-light: #DCEDC8;
  --trainer-bg: #F1F8E9;
}

.trainer-library-header {
  background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-secondary));
  color: white;
  border: none;
  box-shadow: 0 4px 20px 0px rgba(154, 205, 50, 0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
  
  .trainer-card-header {
    background: transparent;
    border: none;
  }
  
  .trainer-title {
    color: white;
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
    }
  }
  
  .trainer-subtitle {
    color: rgba(255,255,255,0.8);
    margin: 0;
  }
  
  .trainer-btn-add {
    border: 2px solid rgba(255,255,255,0.3);
    color: white;
    
    &:hover {
      background: rgba(255,255,255,0.1);
      border-color: rgba(255,255,255,0.5);
    }
  }
}

.trainer-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
  
  .card-header {
    background: var(--trainer-bg);
    border-bottom: 1px solid #dee2e6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .card-title {
      color: var(--trainer-dark);
      font-weight: 600;
      margin: 0;
    }
    
    .card-tools {
      display: flex;
      gap: 5px;
    }
  }
}

.trainer-stats-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 25px 0 rgba(0,0,0,0.15);
    transform: translateY(-2px);
  }
  
  .trainer-number {
    font-size: 24px;
    font-weight: 700;
    color: var(--trainer-dark);
  }
}

.trainer-filter-toggles {
  display: flex;
  gap: 5px;
}

.trainer-exercise-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 25px 0 rgba(0,0,0,0.15);
    transform: translateY(-3px);
  }
  
  .trainer-exercise-image {
    position: relative;
    height: 180px;
    background: #f8f9fa;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .trainer-exercise-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: #ccc;
      font-size: 48px;
    }
    
    .trainer-exercise-overlay {
      position: absolute;
      top: 10px;
      right: 10px;
      display: flex;
      gap: 5px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    &:hover .trainer-exercise-overlay {
      opacity: 1;
    }
  }
  
  .trainer-exercise-content {
    padding: 15px;
    
    .trainer-exercise-name {
      color: var(--trainer-dark);
      font-weight: 600;
      margin-bottom: 8px;
    }
    
    .trainer-exercise-description {
      color: #666;
      font-size: 14px;
      margin-bottom: 10px;
      line-height: 1.4;
    }
    
    .trainer-exercise-meta {
      display: flex;
      gap: 8px;
      margin-bottom: 15px;
      
      .trainer-badge-category {
        background: var(--trainer-primary);
        color: white;
        font-size: 11px;
        padding: 4px 8px;
      }
      
      .trainer-badge-difficulty {
        font-size: 11px;
        padding: 4px 8px;
      }
    }
    
    .trainer-exercise-actions {
      display: flex;
      gap: 8px;
      
      .btn {
        flex: 1;
        font-size: 12px;
        padding: 6px 12px;
      }
    }
  }
}

.trainer-exercises-table {
  .trainer-exercise-info {
    display: flex;
    align-items: center;
    
    .trainer-exercise-thumb,
    .trainer-exercise-placeholder-thumb {
      width: 50px;
      height: 50px;
      margin-right: 12px;
      border-radius: 6px;
    }
    
    .trainer-exercise-thumb {
      object-fit: cover;
    }
    
    .trainer-exercise-placeholder-thumb {
      background: #f8f9fa;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ccc;
    }
  }
  
  .trainer-badge-category {
    background: var(--trainer-primary);
    color: white;
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .trainer-badge-difficulty {
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .trainer-actions {
    display: flex;
    gap: 5px;
    
    .btn {
      padding: 4px 8px;
      font-size: 12px;
    }
  }
}

.trainer-btn-primary {
  background: var(--trainer-primary);
  border-color: var(--trainer-primary);
  color: white;
  
  &:hover {
    background: var(--trainer-secondary);
    border-color: var(--trainer-secondary);
  }
}

.form-control {
  border: 2px solid #e9ecef;
  border-radius: 6px;
  
  &:focus {
    border-color: var(--trainer-primary);
    box-shadow: 0 0 0 0.2rem rgba(154, 205, 50, 0.25);
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  
  .modal-dialog {
    background: white;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    overflow-y: auto;
  }
  
  .modal-header {
    padding: 20px;
    border-bottom: 1px solid #dee2e6;
    
    .modal-title {
      color: var(--trainer-dark);
      font-weight: 600;
    }
    
    .close {
      background: none;
      border: none;
      font-size: 24px;
      line-height: 1;
      color: #999;
      cursor: pointer;
    }
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .modal-footer {
    padding: 20px;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>